import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import { B2BGrid } from '../../../Components';
import {Breadcrumb} from 'react-bootstrap'
import { partnerApi } from '../../../../api';   /*Separate Partners from Operators Filter*/

class B2BTaskforcesViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            year: [],
            month: [],
            bmos: [],
            lbls:[], /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
            industries: [],
            partners:[], /*Separate Partners from Operators Filter*/
            bmos_partners:[]  //Industry partner dropdown selection and filter fix
            //domainmatch:0 //db check domain match for logged in user
        }
        document.title = "Bridge Alliance | 5G B2B"  
    }

    componentDidMount = async () => {
        var _this = this;   /*Separate Partners from Operators Filter*/
        console.log(`Envoirment ${process.env.REACT_APP_MODE}`)
        await this.props.setGeneralData();
        this._setData(1);
        this.setPartners(_this);    /*Separate Partners from Operators Filter*/

        //db check domain match for logged in user
        /*
        let formdata={};
        formdata['userid']= localStorage['currentuserid'];
        this.checkDomainMatch(formdata,_this);
        */
    }

    //db check domain match for logged in user
    /*
    async checkDomainMatch(formdata,_this)
    {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/checkdomain`, {
            timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(formdata)
          })
          .then(res => res.json())
          .then(response => {
            _this.setState({ domainmatch:response});
        })
    }
    */

    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }


    onPageChange = (pageno) => {
        this._setData(pageno);
    }

    /*Separate Partners from Operators Filter*/
    setPartners = async (_this) => {
        //to fetch partners data
        let partnerobj = [];
        let partnersformdata = {
            "posts_per_page": 1000,
            "posts_status": ["publish"],
            "orderby":"post_title",
            "order":"ASC"
        }

        await this.props.searchPartnersJson(
            this.props.token, 1, partnersformdata
        );
        //to fetch partners data
    }
    /*Separate Partners from Operators Filter*/

    _setData = async (page) => {
        let formdata = {
            "posts_per_page": 12,
            "env": process.env.REACT_APP_MODE,
            "post-type": "btobtaskforce",
            "orderby":"post_modified"
        }
        if (this.state.year.length > 0) {
            formdata["year"] = this.state.year[0];
        } if (this.state.month.length > 0) {
            formdata["month"] = this.state.month[0];
        } 

        //added bmos filter //Industry partner dropdown selection and filter fix
        if (this.state.bmos.length > 0) {
            /*Separate Partners from Operators Filter*/
            /*
            if(this.props.data.selected.selected_bridge.length > 0)
            {
                //check selected bridge value matches bmos value then remove those bridge index
                for(var b=0;b<this.state.bmos.length;b++)
                {
                    for (var i = 0; i < this.props.data.selected.selected_bridge.length; i++) {
                        if(this.state.bmos[b] == this.props.data.selected.selected_bridge[i])
                        {
                            this.state.bmos.splice(b,1);
                        }
                    }
                }
                //this.state.bmos.pop(this.props.data.selected.selected_bridge[0]);
            }
            */
            if(this.props.data.selected.selected_partners.length > 0)
            {
                //check selected partners value matches bmos value then remove those bmos index
                for(var b=0;b<this.state.bmos.length;b++)
                {
                    for (var i = 0; i < this.props.data.selected.selected_partners.length; i++) {
                        if(this.state.bmos[b] == this.props.data.selected.selected_partners[i])
                        {
                            this.state.bmos.splice(b,1);
                        }
                    }
                }
            }
        formdata["bmos"] = this.state.bmos;
    } 
    //added bmos filter //Industry partner dropdown selection and filter fix
        
    //added for partners filter //Industry partner dropdown selection and filter fix
    if (this.state.partners.length > 0) {  
        if(this.state.bmos.length > 0){
            //formdata["bmos"].push(this.state.partners[0]);
            for(var p=0; p < this.state.partners.length; p++)
            {
                formdata["bmos"].push(this.state.partners[p]);
            }
            formdata["partners"] = this.state.partners;
        }
        else
        {
            if((formdata["bmos"] != undefined) && (formdata["bmos"].length > 0))
            {
                for(var p=0; p < this.state.partners.length; p++)
                {
                    formdata["bmos"].push(this.state.partners[p]);
                }
                formdata["partners"] = this.state.partners;
            }
            else
            {
                formdata["bmos"] = this.state.partners;
                formdata["partners"] = this.state.partners;
            }
        }
    } 
    //added for partners filter  //Industry partner dropdown selection and filter fix
        
        
        
        if (this.state.industries.length > 0) {
            formdata["industries"] = this.state.industries;
        }

        /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
        if (this.state.lbls.length > 0) {
            formdata["lbls"] = this.state.lbls;
        }
        /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 

        //console.log(formdata);
        await this.props.searchPostsJson(
            this.props.token, page, formdata
        );
    }

    _convertSelectedDataToArray = (e) => {
        let ar = [];
        e.forEach(function (element) {
            ar.push(element.value);
        });
        return ar;
    }
    _onChangeSelect = (e, type) => {
        this.setState({ [type]: this._convertSelectedDataToArray(e) }, () => {
            this._setData(1)
        });
    }


    render = () => {
        return (
            <Layout className="inner-page">
                <div className="container">
                    {/*
                    <Breadcrumb className="mt-4">
                        <Breadcrumb.Item href="/5gb2btaskforces">Verticals</Breadcrumb.Item>
                    </Breadcrumb>
                    */}
                    <h1>5G B2B</h1>      
                    <br/>
                    {(this.props.data!==undefined) && (
                        <B2BGrid
                            industries={this.props.industries}
                            bmos={this.props.bmos}
                            lbls={this.props.lbls} /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
                            partners = {this.props.partners.result} /*Separate Partners from Operators Filter*/
                            bmos_partners = {this.props.bmos_partners}  //Industry partner dropdown selection and filter fix
                            //partners_enable     //added for new filters display in Resource page    /*Separate Partners from Operators Filter*/
                           
                            years   /*Insights Page Additional Dropdown*/
                            data={this.props.data?this.props.data.data:[]}
                            selectedData={this.props.data.selected || {}}
                            selectedPartnerData = {this.props.partners.selected || {} } //Industry partner dropdown selection and filter fix
                            onChange={this._onChangeSelect}
                            currentpage={parseInt(this.props.data?this.props.data.currentpage:0)}
                            max_num_pages={parseInt(this.props.data?this.props.data.max_num_pages:0)}
                            isLoading={this.props.isLoading_posts}
                            posttype={`btobtaskforce`}
                            onPageChange={this.onPageChange}
                            //domainmatch={this.state.domainmatch} //db check domain match for logged in user
                        />
                    )}
                        
               

                </div>
            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default B2BTaskforcesViewContainer;